import styled from "styled-components"

import { spacing, colors, textColorVariables } from "@izettle/otto"

export const LabelWrapper = styled.div<{ disabled: boolean }>`
  margin-left: ${spacing.xSmall};
  overflow: hidden;
  ${({ disabled }) =>
    disabled &&
    `
    ${textColorVariables.primary}: ${colors.text.disabled};
  `}
  & > * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
